// ** I18n Imports
import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { useSelector } from 'react-redux'
import { useEffect } from 'react'

// Initializes i18next
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `/assets/data/locales/{{lng}}.json`
    },
    fallbackLng: 'en',
    debug: false,
    keySeparator: false,
    react: {
      useSuspense: false
    },
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    }
  })

const I18nWrapper = ({ children }) => {
  // استخدام useSelector للحصول على حالة الـ isRTL من الـ Redux store
  const isRTL = useSelector((state) => state.layout.isRTL)

  // استخدام useEffect لتحديث اللغة بناءً على حالة isRTL
  useEffect(() => {
    const lang = isRTL ? 'ar' : 'en'
    i18n.changeLanguage(lang)
  }, [isRTL])

  return children
}

export default I18nWrapper